var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainScreenVue'),_c('TopFeaturesVue'),_c('MainPortfolioVue'),_c('CategoriesBlockVue'),_c('NeedSpecialVue'),_c('FeaturesVue'),_c('StepVue'),_c('SectionFormVue'),_c('InfoBlockVue'),_c('ContactsVue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }